export { SellersFooter, SellersFooterTestIds } from './SellersFooter';
